import React from 'react'
import { useDispatch } from 'react-redux'
import { Avatar, CardHeader } from '@material-ui/core'
import { FaCheck, FaUser, FaDownload, FaEyeSlash } from 'react-icons/fa'
import { changeScreenB } from '../../../store/actions/navigation.action'
import { IoLogoWhatsapp } from "react-icons/io"
import Fullname from '../../components/Fullname'

export default function Detail(props) {
    const dispatch = useDispatch()
    const top = (props.top) ? props.top : {user: null}
    const title = (props.title) ? props.title : null
    const index = (props.index) ? props.index : null

    const [ telefone, setTelefone ] = React.useState(false)

    const handlePage = (page, user_id = null) => {
        dispatch(changeScreenB({
            open: true,
            type: page,
            props: {
                user_id: user_id
            }
        }))
    }

    return (
        <div className="card bs-bg">
            {(top.user) &&
            <>
            <label className="card-body label-custom m-0 pb-1 bs-color-b">{title}</label>
            <CardHeader 
                avatar={
                    <Avatar className="avatar-item">
                        {index ? <span className="fw-bold">{index}</span> : <FaCheck />}
                    </Avatar>
                }
                title={<h5 className="fw-bold m-0 bs-color-b">{top.qtd.toLocaleString('pt-BR', {style: 'decimal'})}</h5>}
                subheader={<small className="fw-bold text-success">COTAS</small>} 
            />

            <hr className="hr-muted m-0"/>

            <label className="card-body label-custom m-0 pb-1 bs-color-b">Cliente</label>
            <CardHeader 
                avatar={
                    <Avatar className="avatar-item">
                        <FaUser />
                    </Avatar>
                }
                title={<h6 className="fw-bold bs-color-b">{<Fullname fullName={top.user.name ? top.user.name.substring(0,25) : top.user.name} />}</h6>}
                subheader={
                    <>
                    <div className="d-flex justify-content-between">
                        <span className="d-block pointer mb-2 bs-color" onClick={() => setTelefone(telefone ? false : true)}>{(telefone) ? top.user.telefone : <> {top.user.telefone.substring(5, -1)} ****** <FaEyeSlash /></>}</span>
                        
                        <span className="me-2">
                            <a href={'http://wa.me/55'+top.user.telefone} target="_blank" rel="noopener noreferrer">
                                <IoLogoWhatsapp color="#24d366" size={30}/>
                            </a>
                        </span>
                    </div>

                    <span onClick={() => handlePage('shopping', top.user_id)} className="pointer fw-bold text-danger">Todas compras</span>
                    </>
                }
            />

            <hr className="hr-muted m-0"/>

            <label className="card-body label-custom m-0 pb-1 bs-color-b">Investiu</label>
            <CardHeader 
                avatar={
                    <Avatar className="avatar-item">
                        <FaDownload />
                    </Avatar>
                }
                title={<h6 className="fw-bold bs-color-b">{new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(top.total)}</h6>}
            />

            </>
            }

            <div className="d-flex justify-content-center card-body">
                <button className="btn btn-light fw-bold" onClick={() => props.onClose() }>
                    Fechar
                </button>
            </div>
        </div>
    )
}